import React, { createRef } from 'react'
import { EditableTextField } from '../common/EditableComponents'
import {
  Button,
  Grid,
  Paper,
  Table,
  TableRow,
  TableBody,
  TableHead,
  TableCell,
  InputLabel,
  Input,
  FormControl,
} from '@material-ui/core'
import { connect } from 'react-redux'
import moment from 'moment'
import {
  SourceType,
  PaymentStatus,
  getPaymentStatus,
  SubscriptionCollectionMethod,
  numberWithCommas,
} from '../../utils/common'
// import InputMask from 'react-input-mask';

//actions
import {
  getStripeCustomer,
  getStripeCustomerPayments,
  updateStripeCustomerAddress,
  updateCompanyEmployeeSeatSubscription,
  setCustomerDefaultSource,
  removeCustomerSource,
  attachCustomerSource,
} from '../../actions/company'
import { openErrorMessage } from '../../actions/message'

// components
import SubscriptionItem from './SubscriptionItem'
import PaymentHistoryItem from './PaymentHistoryItem'
import PaymentDetailItem from './PaymentDetailItem'
import Text from '../common/Text'
import Heading from '../common/Heading'
import NavHeader from '../layout/NavHeader'
import AddCardModal from '../Modal/AddCardModal'
import DefaultSourceModal from '../Modal/DefaultSourceModal'

class BillingInfo extends React.Component {
  rightAlign = {
    textAlign: 'right',
  }
  centerAlign = {
    textAlign: 'center',
    padding: '0 0',
  }

  addCardModal = createRef()

  addDefaultSourceModal = createRef()

  constructor(props) {
    super(props)
    this.state = {
      stripeCustomer: null,
      stripeCustomerPayments: null,
      company: null,
      companyId: null,
      address: null,
      addressEdit: false,
      name: null,
      phone: null,
      email: null,
      employeeSeatPlanId: null,
      subscription: null,
      employeeCount: null,
    }
  }

  openAddCardModal = () => {
    this.addCardModal.current.handleClickOpen()
    // window.open("www.google.com", "_blank")
  }

  openDefaultSourceCardModal = () => {
    this.addDefaultSourceModal.current.handleClickOpen()
  }

  closeDefaultSourceCardModal = () => {
    this.addDefaultSourceModal.current.handleClose()
  }

  closeAddAcardModal = () => {
    this.addCardModal.current.handleClose()
  }

  componentDidMount() {
    const { authReducer } = this.props
    const { session = {} } = authReducer
    const { company } = session
    const companyId = company.id
    this.setState({
      company: company,
      companyId: companyId,
    })
    this.props.dispatch(getStripeCustomer(companyId)).then((res) => {
      const subscriptionEmployeeSeat = this.getEmployeeSeatId(res.subscriptions)
      this.setState({
        stripeCustomer: res,
        employeeSeatPlanId: subscriptionEmployeeSeat.employeeSeatPlanId,
        subscription: subscriptionEmployeeSeat.subscription,
      })
      this.setState({
        address: res.address,
        name: res.name,
        phone: res.phone,
        email: res.email,
      })
      this.props.dispatch(getStripeCustomerPayments(res.id)).then((res) => {
        this.setState({
          stripeCustomerPayments: res,
        })
        ///window.localStorage.setItem('companyFeatures', JSON.stringify(res));
      })
    })
  }

  getEmployeeSeatId(subscriptions) {
    let employeeSeatPlanId = ''
    let subscription = null
    let positiveResponses = ['yes', 'True']
    if (subscriptions) {
      subscriptions.data.forEach((element) => {
        const { plan } = element
        let product = plan && plan.product
        let metadata = product.metadata
        if (
          'isEmployeeSeat' in metadata &&
          positiveResponses.includes(metadata['isEmployeeSeat'])
        ) {
          employeeSeatPlanId = plan.id
          subscription = element
        }
      })
    }
    return {
      subscription: subscription,
      employeeSeatPlanId: employeeSeatPlanId,
    }
    // return employeeSeatPlanId;
  }

  getSubscriptionTotalCost(subscription) {
    let totalCost = 0
    const plan = subscription.plan
    if (plan) {
      let quantity = subscription.quantity
      if (plan.tiers) {
        plan.tiers.forEach((element) => {
          if (quantity === 0) {
            return false
          }
          const maxQuantity = element.up_to
          const flatAmount = element.flat_amount != null ? element.flat_amount / 100 : 0
          const unitAmount = element.unit_amount != null ? element.unit_amount / 100 : 0
          let currentQuantity
          if (maxQuantity && maxQuantity < quantity) {
            currentQuantity = maxQuantity
          } else {
            currentQuantity = quantity
          }
          quantity -= currentQuantity
          totalCost += currentQuantity * unitAmount + flatAmount
        })
      }
    }
    return totalCost
  }

  enableAddressEdit = () => {
    this.setState({
      addressEdit: true,
    })
  }

  disableAddressEdit = () => {
    this.setState({
      addressEdit: false,
    })
  }

  onAddressChange = (key) => (e) => {
    let { address } = this.state
    address[key] = e.target.value
    this.setState({
      address: address,
    })
  }

  onChange = (key) => (e) => {
    const value = e.target ? e.target.value : e
    this.setState({
      [key]: value,
    })
  }

  saveAddress = () => {
    const { companyId, address, name, phone, email } = this.state
    const data = {
      companyId: companyId,
      name: name,
      phone: phone,
      email: email,
      address: {
        address: address ? address.line1 : '',
        city: address ? address.city : '',
        state: address ? address.state : '',
        zipCode: address ? address.postal_code : '',
        country: address ? address.country : '',
        addressLine2: address ? address.line2 : '',
      },
    }
    this.props.dispatch(updateStripeCustomerAddress(data)).then((res) => {
      this.setState({
        addressEdit: false,
      })
    })
  }

  updateEmployeeCount = () => {
    const { companyId, subscription, employeeCount } = this.state
    let subscriptionItemId = ''
    if (subscription.items && subscription.items.data) {
      subscriptionItemId = subscription.items.data[0].id
    }
    const data = {
      companyId: companyId,
      subscriptionId: subscription.id,
      subscriptionItemId: subscriptionItemId,
      quantity: employeeCount,
      employees: [],
    }
    this.props.dispatch(updateCompanyEmployeeSeatSubscription(data)).then((res) => {
      this.props.dispatch(getStripeCustomer(companyId)).then((res) => {
        this.setState({
          stripeCustomer: res,
          addressEdit: false,
        })
      })
    })
  }

  updateAddress = (address) => {
    this.setState({
      address: {
        line1: address.address,
        line2: '',
        state: address.shortName || address.state,
        city: address.city || '',
        country: address.country === 'Canada' ? 'CA' : 'US',
        postal_code: address.zipCode || '',
      },
    })
  }

  onSourceChange = (newSelectedSource) => {
    this.setState({ selectedSource: newSelectedSource })
  }

  setDefault = (newDefaultSource) => {
    const { stripeCustomer } = this.state
    const request = {
      customerId: stripeCustomer.id,
      sourceId: newDefaultSource,
    }
    this.props.dispatch(setCustomerDefaultSource(request)).then((res) => {
      this.closeDefaultSourceCardModal()
      this.getCurrentStripeCustomer()
    })
  }

  getCurrentStripeCustomer = () => {
    const { companyId } = this.state
    this.props.dispatch(getStripeCustomer(companyId)).then((res) => {
      this.setState({
        stripeCustomer: res,
        addressEdit: false,
      })
    })
  }

  attachNewSource = (newSource) => {
    const { stripeCustomer } = this.state
    const data = {
      customerId: stripeCustomer.id,
      sourceId: newSource,
    }
    this.props.dispatch(attachCustomerSource(data)).then((res) => {
      this.closeAddAcardModal()
      this.getCurrentStripeCustomer()
    })
  }

  getSubscriptionsBySourceId = (sourceId) => {
    let subscriptionIds = []
    const { stripeCustomer } = this.state
    //Get subscriptions with the selected source
    if (stripeCustomer.subscriptions) {
      stripeCustomer.subscriptions.data.forEach((element) => {
        if (element.default_source === sourceId) {
          subscriptionIds.push(element.id)
        }
      })
    }
    return subscriptionIds
  }

  deleteSource = (source) => {
    // let subscriptionIds = [];
    // const {stripeCustomer} = this.state;
    // //Get subscriptions with the selected source
    // if (stripeCustomer.subscriptions){
    //     stripeCustomer.subscriptions.data.forEach(element => {
    //         if (element.default_source===source){
    //             subscriptionIds.push(element.id);
    //         }
    //     });
    // }
    const { stripeCustomer } = this.state
    const subscriptionIds = this.getSubscriptionsBySourceId(source)
    const request = {
      customerId: stripeCustomer.id,
      sourceId: source,
      subscriptionIds: subscriptionIds,
    }
    this.props.dispatch(removeCustomerSource(request)).then((res) => {
      // this.addDefaultSourceModal.handleClose();
      this.getCurrentStripeCustomer()
    })
  }

  render() {
    const { stripeCustomer, address, addressEdit, name, phone, email, companyId } = this.state
    let sourceList = []
    let subscriptionList = []
    let paymentHistoryList = []
    let defaultSourceList = []
    let addressLine1, addressLine2, addressLine3
    let sourceMap = new Map()
    let subscriptionMap = new Map()
    if (address) {
      let lastLine = address.city + ', ' + address.state + ' '
      lastLine += address.postal_code + ' ' + address.country

      addressLine1 = address.line1
      addressLine2 = address.line2 != '' ? address.line2 : lastLine // eslint-disable-line
      addressLine3 = address.line2 != '' ? lastLine : '' // eslint-disable-line
    }
    if (stripeCustomer) {
      //Get Sources
      if (stripeCustomer.sources) {
        stripeCustomer.sources.data.forEach((element) => {
          const achCreditTransfer = element.ach_credit_transfer
          const card = element.card
          const defaultSource = element.id === stripeCustomer.default_source ? ' (Default)' : ''
          if (element.object === 'source') {
            let sourceLabel = ''
            if (achCreditTransfer && element.type === SourceType.ACH) {
              const type = 'ACH'
              const accountNumber = achCreditTransfer.account_number
              //Put **** and get the last four digits of Account Number
              const shortAccountNumber = accountNumber.substr(accountNumber.length - 4)
              sourceLabel = '****' + shortAccountNumber
              sourceList.push({
                data: {
                  id: element.id,
                  accountNumber: shortAccountNumber,
                  longAccountNumber: sourceLabel,
                  type: type,
                  expirationDate: '-',
                  subscriptionsId: this.getSubscriptionsBySourceId(element.id),
                },
              })
            }
            if (element.card && element.type === SourceType.Card) {
              const type = card.brand
              const month = card.exp_month > 9 ? card.exp_month.toString() : '0' + card.exp_month
              const year = card.exp_year.toString().substr(card.exp_year.toString().length - 2)
              sourceLabel = '************' + card.last4
              sourceList.push({
                data: {
                  id: element.id,
                  accountNumber: card.last4,
                  longAccountNumber: sourceLabel,
                  type: type + defaultSource,
                  expirationDate: month + '/' + year,
                  subscriptionsId: this.getSubscriptionsBySourceId(element.id),
                },
              })
            }
            defaultSourceList.push({
              value: element.id,
              label: sourceLabel,
            })
            sourceMap.set(element.id, sourceLabel)
          }
        })
      }
      //Get Subscriptions
      if (stripeCustomer.subscriptions) {
        stripeCustomer.subscriptions.data.forEach((element) => {
          const { plan } = element
          if (plan) {
            //Get Payment Method if possible
            let source = '-'
            let sourceId = ''
            if (element.collection_method === SubscriptionCollectionMethod.Charge) {
              if (element.default_source && sourceMap.has(element.default_source)) {
                sourceId = element.default_source
              } else {
                sourceId = stripeCustomer.default_source
              }
              source = sourceMap.get(sourceId)
            }
            subscriptionList.push({
              data: {
                id: element.id,
                quantity: numberWithCommas(element.quantity),
                name: plan.nickname,
                totalCost: '$ ' + numberWithCommas(this.getSubscriptionTotalCost(element)),
                source: source,
                sourceId: sourceId,
              },
              subscription: element,
            })
            subscriptionMap.set(element.id, plan.nickname)
          }
        })
      }
    }
    const { stripeCustomerPayments } = this.state
    //Get Payments
    if (stripeCustomerPayments) {
      stripeCustomerPayments.data.forEach((element) => {
        let status = getPaymentStatus(element.status)
        let date = null
        let description = null
        if (element.status === PaymentStatus.canceled) {
          date = moment.unix(element.canceled_at).format('MM/DD/YYYY')
        }
        const invoice = element.invoice
        let period
        if (invoice) {
          let lines = invoice.lines
          if (lines && lines.data && lines.data.length > 0) {
            const line = lines.data[0]
            if (line.period) {
              const periodStart = moment.unix(line.period.start).format('MM/DD/YYYY')
              const periodEnd =
                line.period.end != null ? moment.unix(line.period.end).format('MM/DD/YYYY') : null
              period = periodStart + ' - ' + periodEnd
            }
            if (line.plan) {
              description = line.plan.nickname
            }
          }
          const statusTransitions = invoice.status_transitions
          if (statusTransitions && PaymentStatus.succeeded) {
            date = moment.unix(statusTransitions.paid_at).format('MM/DD/YYYY')
          }
        }
        let source = ''
        if (element.source && sourceMap.has(element.source)) {
          source = sourceMap.get(element.source)
        }
        paymentHistoryList.push({
          editMode: false,
          data: {
            amount: '$ ' + numberWithCommas(element.amount / 100),
            status: status,
            description: description,
            period: period,
            date: date,
            source: source,
          },
          payment: element,
        })
      })
    }
    const checkStripeAPIKey = process.env.REACT_APP_API_KEY === undefined
    if (checkStripeAPIKey) {
      this.props.dispatch(openErrorMessage('Stripe API Key not set'))
    }
    return (
      // center-aligned-child
      <Grid container spacing={3} justify="space-around">
        <NavHeader />
        <Grid item lg={8} className="margin">
          <Heading className="font-normal vertical-middle total-shops">Subscriptions Plans</Heading>
          <div className="table-scroll cus-pager-top">
            <Paper>
              <Table>
                <colgroup>
                  <col width="30%" />
                  <col width="10%" />
                  <col width="25%" />
                  <col width="20%" />
                  <col width="15%" />
                </colgroup>
                <TableHead>
                  <TableRow>
                    <TableCell>Product</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>Quantity</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>Total Cost</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>Payment Source</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {subscriptionList.map((row, index) => {
                    return (
                      <SubscriptionItem
                        key={index}
                        editMode={row.editMode}
                        data={row.data}
                        subscription={row.subscription}
                        sourceList={defaultSourceList}
                        dispatch={this.props.dispatch}
                        getCustomer={this.getCurrentStripeCustomer}
                      />
                    )
                  })}
                </TableBody>
              </Table>
            </Paper>
          </div>
          <Heading className="font-normal vertical-middle total-shops">Payment History</Heading>
          <div className="table-scroll cus-pager-top">
            <Paper>
              <Table>
                <colgroup>
                  <col width="20%" />
                  <col width="20%" />
                  <col width="20%" />
                  <col width="12%" />
                  <col width="20%" />
                  <col width="8%" />
                </colgroup>
                <TableHead>
                  <TableRow>
                    <TableCell>Period</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell style={this.centerAlign}>Amount</TableCell>
                    <TableCell style={this.centerAlign}>
                      Paid On/
                      <br />
                      Canceled On
                    </TableCell>
                    <TableCell style={this.centerAlign}>Status</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paymentHistoryList.map((row, index) => {
                    return (
                      <PaymentHistoryItem
                        key={index}
                        editMode={row.editMode}
                        data={row.data}
                        payment={row.payment}
                      />
                    )
                  })}
                </TableBody>
              </Table>
            </Paper>
          </div>
        </Grid>
        <Grid item lg={3} className="">
          <Heading className="font-normal vertical-middle total-shops">Payment Sources</Heading>
          <div className="table-scroll cus-pager-top">
            <Paper>
              <Table>
                {/* <colgroup>
                                    <col key="1" width="60%" />
                                    <col key="2" width="10%" />
                                    <col key="3" width="10%" />
                                    <col key="4" width="10%"/>
                                </colgroup> */}
                <TableHead>
                  <TableRow>
                    <TableCell style={this.centerAlign} colSpan={2}>
                      Source
                    </TableCell>
                    <TableCell style={this.centerAlign}>Last 4 Digits</TableCell>
                    <TableCell style={this.centerAlign}>
                      Expiration
                      <br />
                      Date
                    </TableCell>
                    <TableCell style={this.centerAlign}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sourceList.map((row, index) => {
                    return (
                      <PaymentDetailItem
                        onSourceChange={this.onSourceChange}
                        key={index}
                        editMode={false}
                        data={row.data}
                        defaultSource={stripeCustomer.default_source}
                        deleteSource={this.deleteSource}
                        subscriptionMap={subscriptionMap}
                        sourceMap={sourceMap}
                      />
                    )
                  })}
                  <TableRow>
                    <TableCell colSpan={5} style={this.rightAlign} className="padding-small">
                      <Button
                        size="small"
                        disabled={checkStripeAPIKey}
                        variant="outlined"
                        color="secondary"
                        className="margin"
                        onClick={this.openAddCardModal}
                      >
                        Add
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        color="primary"
                        className="margin"
                        onClick={this.openDefaultSourceCardModal}
                      >
                        Set Default
                      </Button>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Paper>
          </div>
          <Heading className="font-normal vertical-middle total-shops">Billing Address</Heading>
          <div className="table-scroll cus-pager-top">
            <Paper>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <Text>Name</Text>
                      <FormControl fullWidth className="margin-bottom-small">
                        <EditableTextField
                          value={name}
                          valueToRender={name}
                          editMode={addressEdit}
                          onChange={this.onChange('name')}
                        />
                      </FormControl>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    {addressEdit ? (
                      <TableCell>
                        <Text>Address</Text>
                        {/* <FormControl fullWidth className="margin-bottom-small">
                                                        <GooglePlacesAddress placeholder="Google Search" updateAddress={this.updateAddress} value={address?address.line1:""}/>  
                                                    </FormControl> */}
                        <FormControl fullWidth className="margin-bottom-small">
                          <InputLabel>Address Line 1</InputLabel>
                          <Input
                            value={address ? address.line1 : ''}
                            onChange={this.onAddressChange('line1')}
                            fullWidth
                            placeholder="Address Line 1"
                          />
                        </FormControl>
                        <FormControl fullWidth className="margin-bottom-small">
                          <InputLabel>Address Line 2</InputLabel>
                          <Input
                            value={address ? address.line2 : ''}
                            onChange={this.onAddressChange('line2')}
                            fullWidth
                            placeholder="Address Line 2"
                          />
                        </FormControl>
                        <FormControl fullWidth className="margin-bottom-small">
                          <InputLabel>City</InputLabel>
                          <Input
                            value={address ? address.city : ''}
                            onChange={this.onAddressChange('city')}
                            fullWidth
                            placeholder="City"
                          />
                        </FormControl>
                        <FormControl fullWidth className="margin-bottom-small">
                          <InputLabel>State</InputLabel>
                          <Input
                            value={address ? address.state : ''}
                            onChange={this.onAddressChange('state')}
                            fullWidth
                            placeholder="State"
                          />
                        </FormControl>
                        <FormControl fullWidth className="margin-bottom-small">
                          <InputLabel>Country</InputLabel>
                          <Input
                            value={address ? address.country : ''}
                            onChange={this.onAddressChange('country')}
                            fullWidth
                            placeholder="Country"
                          />
                        </FormControl>
                        <FormControl fullWidth className="margin-bottom-small">
                          <InputLabel>Zip Code</InputLabel>
                          <Input
                            value={address ? address.postal_code : ''}
                            onChange={this.onAddressChange('postal_code')}
                            fullWidth
                            placeholder="Zip COde"
                          />
                        </FormControl>
                      </TableCell>
                    ) : (
                      <TableCell>
                        <Text>Address</Text>
                        <EditableTextField
                          value={addressLine1}
                          valueToRender={addressLine1}
                          editMode={addressEdit}
                          placeholder="Line 1"
                        />
                        <br />
                        <EditableTextField
                          value={addressLine2}
                          valueToRender={addressLine2}
                          editMode={addressEdit}
                          placeholder="Line 2"
                        />
                        <br />
                        {addressLine3 != '' ? ( // eslint-disable-line
                          <EditableTextField
                            value={addressLine3}
                            valueToRender={addressLine3}
                            editMode={addressEdit}
                            placeholder="City"
                          />
                        ) : null}
                      </TableCell>
                    )}
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Text>Phone</Text>
                      <FormControl fullWidth className="margin-bottom-small">
                        <EditableTextField
                          value={phone}
                          valueToRender={phone}
                          editMode={addressEdit}
                          onChange={this.onChange('phone')}
                        />
                      </FormControl>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Text>Email</Text>
                      <FormControl fullWidth className="margin-bottom-small">
                        <EditableTextField
                          value={email}
                          valueToRender={email}
                          editMode={addressEdit}
                          onChange={this.onChange('email')}
                        />
                      </FormControl>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    {!addressEdit ? (
                      <TableCell style={this.rightAlign} className="padding-small">
                        <div text-align="right">
                          <Button
                            size="small"
                            variant="outlined"
                            color="primary"
                            className="margin"
                            onClick={this.enableAddressEdit}
                          >
                            Edit
                          </Button>
                        </div>
                      </TableCell>
                    ) : (
                      <TableCell style={this.rightAlign} className="padding-small">
                        <Button
                          size="small"
                          variant="outlined"
                          color="primary"
                          className="margin"
                          onClick={this.saveAddress}
                        >
                          Save
                        </Button>
                        <Button
                          size="small"
                          variant="outlined"
                          color="primary"
                          className="margin"
                          onClick={this.disableAddressEdit}
                        >
                          Cancel
                        </Button>
                      </TableCell>
                    )}
                  </TableRow>
                </TableBody>
              </Table>
            </Paper>
          </div>
        </Grid>
        <AddCardModal
          ref={this.addCardModal}
          addCard={this.addCard}
          onError={this.onError}
          stripeCustomer={stripeCustomer}
          companyId={companyId}
          dispatch={this.props.dispatch}
          attachNewSource={this.attachNewSource}
        />
        <DefaultSourceModal
          ref={this.addDefaultSourceModal}
          sourceList={defaultSourceList}
          setDefault={this.setDefault}
        />
      </Grid>
    )
  }
}

export default connect((state) => ({
  authReducer: state.authReducer,
  dispatch: state.dispatch,
}))(BillingInfo)



// WEBPACK FOOTER //
// ./src/components/Billing/BillingInfo.js